import { DocFlowMappingWidgetWithSelectedAreaNotificationType } from './useDocFlowMappingWidgetWithSelectedArea.constants'

export function isNotificationPhase(key) {
  return key === DocFlowMappingWidgetWithSelectedAreaNotificationType.Phase
}

export function isEmptyArea({ areaType, hasAreaCellName, processData }) {
  return processData[areaType]?.length === 0 || !processData?.[hasAreaCellName]
}

export function isAreaNotChanged({
  areaType,
  hasAreaCellName,
  isAreaValue,
  isChanged,
  processData,
  values,
}) {
  return (
    !isChanged &&
    isEmptyArea({ areaType, hasAreaCellName, processData }) &&
    isAreaValue(values)
  )
}
